import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { CustomTranslateService } from '../providers/customTranslate.service';

/**
 * Formats the currency value with appropriate currency symbol based on the current language chosen using the {@link CustomTranslateService}
 */
@Pipe({
  name: 'localizedCurrencyPipe',
  pure: true
})
export class LocalizedCurrencyPipe implements PipeTransform {

  constructor(private translateService: CustomTranslateService) {  }

  transform(value: any): any {
    const currencyPipe: CurrencyPipe = new CurrencyPipe(this.translateService.getCurrentLanguage());

    return currencyPipe.transform(value, this.translateService.getCurrencyCode(), 'symbol');
  }

}

